const csv = 'order_id,sales_order_number,purchase_order_number,date_shipped,tracking_number,carrier,service_level';

export default csv;